export interface FetchVisitorsParams {
  query: string;
  buildingId: string;
}

export interface FetchVisitorsResponse {
  data: Visitor[];
  total: number;
}

export interface Visitor {
  uuid: string;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
  type: VisitorType;
}

export enum VisitorType {
  USER = 'user',
  EXTERNAL = 'external',
}
